import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import PerceptionTestSection from '../components/PerceptionTestSection';
import DiagnosticAnalysisSection from '../components/DiagnosticAnalysisSection';
import ProcessSection from '../components/ProcessSection';
import DeliverablesSection from '../components/DeliverablesSection';
import PricingSection from '../components/PricingSection';
import TargetAudienceSection from '../components/TargetAudienceSection';
import MethodologySection from '../components/MethodologySection';
import CTASection from '../components/CTASection';

export const LandingPage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.fade-in-section');
    animatedElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page">
      <Navigation />
      <HeroSection />
      <ProblemSection />
      <PerceptionTestSection />
      <DiagnosticAnalysisSection />
      <ProcessSection />
      <DeliverablesSection />
      <PricingSection />
      <TargetAudienceSection />
      <MethodologySection />
      <CTASection />
    </div>
  );
};

export default LandingPage;
